import React from "react";
import { Link } from "react-router-dom";
import {
  FileText,
  Globe,
  UserPlus,
  AlertCircle,
  Mail,
} from "lucide-react";
import { quickLinks } from "../mock";

const iconMap = { FileText, Globe, UserPlus, AlertCircle, Mail };

const Footer = () => {
  return (
    <footer className="bg-white">
      {/* Quick links bar */}
      <div className="border-t border-b border-slate-200">
        <div className="max-w-[1280px] mx-auto px-4 py-8 grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {quickLinks.map((q, i) => {
            const Icon = iconMap[q.icon];
            const content = (
              <div className="flex items-center gap-3 group cursor-pointer">
                <div className="w-12 h-12 rounded-md border border-slate-200 flex items-center justify-center text-[#1c4d9c] group-hover:border-[#1c4d9c] group-hover:bg-[#1c4d9c]/5 transition">
                  <Icon className="w-5 h-5" />
                </div>
                <div className="text-[13px] leading-tight">
                  <p className="font-semibold text-slate-800 group-hover:text-[#1c4d9c] transition">
                    {q.label}
                  </p>
                </div>
              </div>
            );
            return q.link ? (
              <Link key={i} to={q.link}>
                {content}
              </Link>
            ) : (
              <div key={i}>{content}</div>
            );
          })}
        </div>
      </div>

      {/* Disclaimer */}
      <div className="max-w-[1280px] mx-auto px-4 py-10 text-[12px] text-slate-500 leading-relaxed">
        <p>
          Burada yer alan bilgiler Acar Menkul Değerler A.Ş. tarafından
          bilgilendirme amacı ile hazırlanmıştır. Yatırım bilgi, yorum ve
          tavsiyeleri yatırım danışmanlığı kapsamında değildir. Yatırım
          danışmanlığı hizmeti; aracı kurumlar, portföy yönetim şirketleri,
          mevduat kabul etmeyen bankalar ile müşteri arasında imzalanacak
          yatırım danışmanlığı sözleşmesi çerçevesinde sunulmaktadır. Burada yer
          alan yorum ve tavsiyeler, yorum ve tavsiyede bulunanların kişisel
          görüşlerine dayanmaktadır. Bu görüşler mali durumunuz ile risk ve
          getiri tercihlerinize uygun olmayabilir. Bu nedenle, sadece burada
          yer alan bilgilere dayanılarak yatırım kararı verilmesi
          beklentilerinize uygun sonuçlar doğurmayabilir.
        </p>
        <p className="mt-4">
          Bu sayfalarda yer alan bilgilerin kullanılması sonucunda oluşabilecek
          doğrudan ve/veya dolaylı zararlardan ve her ne şekil ve surette olursa
          olsun üçüncü kişilerin uğrayabileceği her türlü zararlardan dolayı Acar
          Menkul Değerler A.Ş. sorumlu tutulamaz. BIST piyasalarında oluşan tüm
          verilere ait telif hakları tamamen BIST'e ait olup, bu bilgiler son
          kapanış verileri ile hesaplanmıştır.
        </p>
      </div>

      {/* Bottom bar */}
      <div className="bg-[#1c4d9c] text-white">
        <div className="max-w-[1280px] mx-auto px-4 py-5 text-center">
          <div className="text-[13px] opacity-95">
            © {new Date().getFullYear()} Acar Menkul Değerler A.Ş. Tüm Hakları Saklıdır.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
